export enum ImageDialogState {
  CHOOSE = 0,
  RESULT = 1
}

export enum ProductStart {
  DIRECTLY = 'directly',
  DATE = 'onDate'
}

export enum CountryCode {
  NL = 'NL',
  BE = 'BE',
  DK = 'DK',
  FR = 'FR',
  DE = 'DE',
  GR = 'GR',
  IT = 'IT',
  LU = 'LU',
  ES = 'ES',
  SE = 'SE',
  CH = 'CH',
  GB = 'GB',
  US = 'US'
}
